// components/AnimatedRoutes.jsx
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import AboutMe from './pages/About-Me';
import Inquire from './pages/Inquire';
import PortfolioCar from './pages/Portfolio-Car';
import PortfolioMotorsports from './pages/Portfolio-Motorsports';
import PortfolioEvents from './pages/Portfolio-Events';
import PortfolioSports from './pages/Portfolio-Sports';
import PortfolioPortraits from './pages/Portfolio-Portraits';
import PortfolioTravel from './pages/Portfolio-Travel';
import Confirmation from './pages/Confirmation';

const pageVariants = {
  initial: { opacity: 0, y: 10 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -10 },
};

const pageTransition = {
  type: 'tween',
  ease: 'easeInOut',
  duration: 0.3,
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
    <Routes location={location} key={location.pathname}>
        <Route path="/" element={<motion.div layout initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><Home /></motion.div>} />
        <Route path="/portfolio" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><Portfolio /></motion.div>} />
        <Route path="/portfolio/cars" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><PortfolioCar /></motion.div>} />
        <Route path="/portfolio/motorsports" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><PortfolioMotorsports /></motion.div>} />
        <Route path="/portfolio/events" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><PortfolioEvents /></motion.div>} />
        <Route path="/portfolio/sports" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><PortfolioSports /></motion.div>} />
        <Route path="/portfolio/portraits" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><PortfolioPortraits /></motion.div>} />
        <Route path="/portfolio/travel" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><PortfolioTravel /></motion.div>} />
        <Route path="/about-me" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><AboutMe /></motion.div>} />
        <Route path="/inquire" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><Inquire /></motion.div>} />
        <Route path="/confirmation" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}><Confirmation /></motion.div>} />
    </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
